module.exports = __webpack_public_path__ + "static/media/bkn-logo.dfe8d42a.png";